import React from 'react'

import { useModal } from '../state/ModalProvider'

import { CancelSubscriptionModal } from './CancelSubscriptionModal'
import { EditDealModal } from './EditDealModal'
import { FirstInvoiceModal } from './FirstInvoiceModal'
import { InvoicePreviewOverlay } from './InvoicePreviewOverlay'
import { SendInvoiceModal } from './SendInvoiceModal'

export const ModalRoot: React.FunctionComponent = () => {
  const { current } = useModal()
  if (!current) return null

  if (current.kind === 'edit-deal') {
    return (
      <EditDealModal
        isNew={!!current.isNew}
        dealId={current.dealId}
        initialTab={current.initialTab}
        highlightShipmentId={current.highlightShipmentId}
      />
    )
  }

  if (current.kind === 'cancel-subscription') {
    return <CancelSubscriptionModal dealId={current.dealId} />
  }

  if (current.kind === 'send-invoice') {
    return <SendInvoiceModal dealId={current.dealId} invoiceId={current.invoiceId} />
  }

  if (current.kind === 'invoice-preview') {
    return <InvoicePreviewOverlay dealId={current.dealId} invoiceId={current.invoiceId} />
  }

  if (current.kind === 'first-invoice') {
    return <FirstInvoiceModal dealId={current.dealId} />
  }

  // confirm modal lands in its respective downstream change.
  return null
}
